const { formatStrikethrough } = require("../filters/formatStrikeThrough");

// this component is used as a mixin to provide common functionality for navigable-toc-item and static-toc-item components
const hasAvailableFacsimiles = function(model) {
    if(model.facsimiles && model.facsimiles.length > 0) {
        for(const node of model.facsimiles) {
            if(node.available) return true;
        }
    }

    if(model.contents && model.contents.length > 0) {
        for(const content of model.contents) {
            if(hasAvailableFacsimiles(content)) {
                return true;
            }
        }
    }

    return false;
};

export default {
    name: "TocItem",
    props: ["level", "maxDepth", "model", "parent", "position", "type", "isTranslation", "author", "work"],
    data: function () {
        return {
          children: [],
          open: false,
          thisItem: this
        }
    },

    computed: {
        anchor: function() {
            let node = this;
            const positionElements = [node.position];
            while(node.hasParent)
            {
                node = node.parent;
                positionElements.push(node.position);
            }

            return positionElements.reverse().join("-");
        },

        contents: function() {
            if(this.model.facsimiles.length == 0) {
                return this.model.contents;
            }
            else
            {
                const contentCopy = this.model.contents.slice();
                contentCopy.unshift({
                        contents: [],
                        facsimiles: this.model.facsimiles,
                        firstAvailableFacsimile: this.model.firstAvailableFacsimile,
                        title: this.model.title,
                        type: this.model.type
                });
                return contentCopy;
            }
        },

        hasChildren: function () {
            return this.model.contents && this.model.contents.length > 0
        },

        hasParent: function() {
            return this.parent != null && this.parent.model != null;
        },

        isAvailable: function() {
            return hasAvailableFacsimiles(this.model);
        },

        isLeaf: function() {
            return this.model.facsimiles && this.model.facsimiles.length > 0;
        },

        isFirstleafForCurrentPage: function() {
            if(this.isLeafForCurrentPage) {
                const siblings = this.parent.children.filter(sibling => sibling.isLeafForCurrentPage);
                return siblings[0] === this;
            }
            return false;
        },

        isLeafForCurrentPage: function() {
            if(this.model.contents.length == 0) {
                const pageId = this.$route.params.id;
                for(const facsimile of this.model.facsimiles) {
                    if(facsimile.id === pageId) return true;
                }
            }
            return false;
        },

        isProjectPage: function() {
            return this.$route.params && this.$route.params.section && this.$route.params.section === "projekte";
        },

        tocLevelClass: function() {
            if(this.type === "aside") {
                return "";
            } else {
                return `is-size-${this.level}`;
            }
        }
    },

    filters: {
        formatStrikethrough
    },
    methods: {

        route: function() {
            const id = this.model.firstAvailableFacsimile || this.model.facsimiles.find((f) => f.available).id;

            // close modal, if it was open
            document.querySelector(".modal-close")?.click();

            // TODO: translation routes!
            if(this.isTranslation) {
                console.log("translation toc!");
                if (this.author && this.work) {
                    console.log(`/translations/${this.author}/${this.work}`);
                    this.$router.push({ path: `/translations/${this.author}/${this.work}` });
                }
            }
            else {
                this.$router.push({ path: `/seite/${this.$route.params.section}/${id}` });
            }
        },

        toggle: function () {
            if (this.hasChildren) {
                this.open = !this.open
            }
        }
    },

    mounted() {
        if(this.hasParent)
        {
            this.parent.children.push(this);
        }
    },

    watch: {

        isFirstleafForCurrentPage: function(newValue, oldValue) {
            if(!oldValue && newValue){
                let item = this;
                while(item.hasParent) {
                    item.open = true;
                    item = item.parent;
                }
                item.open = true;
            }
        }
    }
}